import React from 'react';
import { observer } from 'mobx-react';
import {DailyDealContainerBox} from "./boxes/daily-deal-container.box";
import {DailyDealChestGlowBox} from "./boxes/daily-deal-chest-glow.box";
import {DailyDealChestBox} from "./boxes/daily-deal-chest.box";
import {DailyDealTextStripBox} from "./boxes/daily-deal-text-strip.box";
import {DailyDealChestHaloBox} from "./boxes/daily-deal-chest-halo.box";
import {CyClass} from "../../../common/cy-classes";
import {ComponentServicesPick} from "../../services/component-services-pick";
import {useServices} from "../../react-hooks/use-services.hook";
import {withServices} from "../../react-hooks/with-services";

interface DailyDealComponentProps extends ComponentServicesPick<'dailyDeal' | 'bottomNavigationBar'> {
    
}

const ComponentBody: React.FC<DailyDealComponentProps> = observer((props) => {
    const services = useServices();
    const _onDailyDealClick = async () => {
        services.analytics.sendAnalytics('Daily_Deal', 'Click', services.arenas.getCurrentArena().arenaName);
        props.dailyDeal.visitDailyDeal();
    }

    if (!props.dailyDeal.dailyDealCampaignId) {
        return null;
    }

    return (
        <DailyDealContainerBox isBottomNavbarEnabled={props.bottomNavigationBar.isBottomNavigationEnabled}
                               onClick={_onDailyDealClick}
                               className={CyClass('cy-daily-deal-box')}>
            <DailyDealChestGlowBox />
            <DailyDealChestHaloBox />
            <DailyDealTextStripBox> {services.translation.translate("DAILY_DEAL_WIDGET_STRIP") } </DailyDealTextStripBox>
            <DailyDealChestBox src={services.theme.currentTheme.images.dailyDeal.chest.toString()} alt="DailyDeal Chest!"/>
        </DailyDealContainerBox>
    );
    
})
export const DailyDealComponent = withServices(ComponentBody, ['dailyDeal', 'bottomNavigationBar']);